import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";

const NAV_ITEMS = [
  { label: "Divisions", href: "#divisions" },
  { label: "Membership", href: "#membership" },
  { label: "Operations", href: "#operations" },
  { label: "Why CAMO", href: "#why-camo" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-2xl bg-black/70 border-b border-zinc-900" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo-link" className="flex items-center">
          <Logo size="sm" />
        </a>

        <ul className="hidden md:flex items-center gap-10">
          {NAV_ITEMS.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                data-testid={`nav-link-${item.label.toLowerCase().replace(/\s/g, "-")}`}
                className="font-mono text-[11px] tracking-[0.25em] uppercase text-zinc-400 hover:text-white transition-colors duration-300"
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <a
          href="#membership"
          data-testid="nav-cta-member"
          className="hidden md:inline-block font-mono text-[11px] tracking-[0.25em] uppercase border border-white px-5 py-2.5 hover:bg-white hover:text-black transition-colors duration-300"
        >
          Become a Member
        </a>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-white"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-zinc-900 bg-black/95 backdrop-blur-xl">
          <ul className="flex flex-col px-6 py-6 gap-5">
            {NAV_ITEMS.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  onClick={() => setOpen(false)}
                  data-testid={`nav-mobile-link-${item.label.toLowerCase().replace(/\s/g, "-")}`}
                  className="font-mono text-xs tracking-[0.25em] uppercase text-zinc-300"
                >
                  {item.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href="#membership"
                onClick={() => setOpen(false)}
                data-testid="nav-mobile-cta-member"
                className="inline-block font-mono text-xs tracking-[0.25em] uppercase border border-white px-5 py-2.5"
              >
                Become a Member
              </a>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
